import { createSelector } from 'reselect'

const getBinders = state => state.binders

const binder_get_lessons_selector = createSelector(
	[ getBinders ],
	binders => ({
		binders: binders.current,
		entityUID: binders.current.entityUID,
		page: binders.current.page,
		searching_page: binders.current.searching_page,
		order_field: binders.current.order_field,
		order_type: binders.current.order_type,
	})
)

export default binder_get_lessons_selector
